//import the sdk
import AWS from "aws-sdk";
import {AWS_CONFIG} from "../config-global";

//configure the keys
AWS.config.update({
  accessKeyId: AWS_CONFIG.accessKeyId,
  secretAccessKey: AWS_CONFIG.secretAccessKey,
  region: AWS_CONFIG.region,
});

export default AWS;
